import React from 'react';
import AddToDo from './components/AddToDo';
import './css/App.css'
const App = () => {
  return (
    <div
    className='main-wrapper'>
      <AddToDo/>
    </div>
  )
}

export default App;